(function() {
    "use strict";

    angular.module("laekkerAI.tablet").component("homeButton", {
        templateUrl: "components/home-button/home-button.html",
        controller: "HomeButtonController",
        bindings: {}
    });
})();
